<template>
  <div class="statistical_form_detail">
    <div class="tit">
      <span><router-link
          to="/personal_center/enterprise/statistical/table_list"
          class="back"
        >
          <i class="el-icon-arrow-left"></i>
        </router-link>企业数据统计汇报</span>
    </div>
    <div class="body_content">
      <div class="StatisticByEnterprise" v-if="StatisticByEnterprise">
        <h2>{{StatisticByEnterprise.name}}</h2>
        <el-row class="my_row">
          <el-col :span="12">发布时间：{{StatisticByEnterprise.create_date}}</el-col>
          <el-col :span="12">填报截至时间：{{StatisticByEnterprise.end_date}}</el-col>
        </el-row>
        <p>{{StatisticByEnterprise.remark}}</p>
      </div>
      <el-form class="mystatisticalform" :model="params"  ref="myform" label-position="top">
        <el-row>
          <el-col :span="12">
            <el-form-item label-width="170px" prop="name" label="企业名称：">
              <el-input
                class="input-width"
                placeholder="请输入“企业全称”，需与营业执照一致"
                maxlength="30"
                show-word-limit
                v-model="params.name"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否大学生创业企业:"
              prop="is_usiu"
              :rules="[{ required: true, message: '是否大学生创业企业', trigger: 'blur' }]"
            >
              <el-radio-group v-model="params.is_usiu" disabled>
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              prop="total_income"
              label="本年度累计收入（万元）："
              :rules="[{ required: true, message: '请填写本年度累计收入', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.total_income" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="total_tax"
              label="累计纳税总额（万元）："
              :rules="[{ required: true, message: '请填写累计纳税总额', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.total_tax" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item
              prop="total_finance"
              label="当期获得投融资总额（含银行贷款/股权投资等）（万元）："
              :rules="[{ required: true, message: '请填写当期获得投融资总额（含银行贷款/股权投资等）', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.total_finance" disabled></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item
              prop="total_finance_year"
              label="本年度累计获得投融资总额（含银行贷款、股权投资等）（万元）："
              :rules="[{ required: true, message: '请填写本年度累计获得投融资总额（含银行贷款、股权投资等））', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.total_finance_year" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="text_1"
              label="其中获得天使或风险投资（万元）："
              :rules="[{ required: true, message: '请填写就业人员数量', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.text_1" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="total_employee"
              label="就业人员数量（人）："
              :rules="[{ required: true, message: '请填写就业人员数量', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.total_employee" disabled></el-input>
            </el-form-item>
          </el-col>
          
          <!-- <el-col :span="12">
            <el-form-item
              prop="total_recruit"
              label="当期新招聘人员数量（人）："
              :rules="[{ required: true, message: '请填写当期新招聘人员数量', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.total_recruit" disabled></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item
              prop="total_recruit_higher"
              label="其中，应届大学毕业生人数，含大专（人）："
              :rules="[{ required: true, message: '请填写其中，应届大学毕业生人数（含大专）', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.total_recruit_higher" disabled></el-input>
            </el-form-item>
          </el-col>
       
          <el-col :span="12">
            <el-form-item
              prop="contact"
              label="填报人姓名："
              :rules="[{ required: true, message: '请填写填报人姓名', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.contact" maxlength="20" show-word-limit disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="contact_position"
              label="职位："
              :rules="[{ required: true, message: '请填写职位', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.contact_position" maxlength="20" show-word-limit disabled></el-input>
            </el-form-item>
          </el-col>
      
          <el-col :span="12">
            <el-form-item
              prop="contact_phone"
              label="联系方式："
              :rules="[{ required: true, message: '请填写联系方式', trigger: 'blur' }]"
            >
              <el-input class="input-width" v-model="params.contact_phone" maxlength="20" show-word-limit disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <h2>附件</h2>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label-width="170px"
              prop="file"
              label=""
            >
               <div class="myupload">
                  <div class="myupload_l">
                    <uploadFile :params="params" :apiParams="apiParams6"></uploadFile>
                  </div>
                  <div class="myupload_r">
                    <p>1.企业通过认证之后进行的企业名称变更，请上传新营业执照和企业名称变更证明。（未进行过变更的企业无需上传该附件）</p>
                    <p>2.文件名格式名为《企业名称-名称变更说明》，格式为PDF/RAR/ZIP，大小不超过10MB。</p>
                    <p v-if="params.filePath">
                      <a
                        target="_blank"
                        style="color: rgb(50, 130, 255); cursor: pointer; text-decoration: underline;"
                        :href="params.filePath"
                        download
                      >查看附件</a>
                    </p>
                  </div>
                </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import uploadFile from "@/components/file_upload/uploadFile.vue";
export default {
  components: {
    uploadFile,
  },
  data() {
    return {
      params: {},
      loading: false,
      StatisticByEnterprise: null, //企业查询填报状态
      apiParams6: {
        params: {
          catalog: "CatalogActivityCover"
        },
        size: 10, //文件大小
        type: "ysb|pdf", //类型 pdf ysb(压缩包包含rar和zip) zip rar
        imgPath: "filePath", //文件路径字段
        fileId: "file", //文件id字段
        disabled:true
      },
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    if (this.$store.state.info) {
      this.initPage(); /** 查询认证 用于二次编辑*/
    } else {
      this.needInfo("initPage");
    }
   
  },
  methods: {
    async initPage() {
      await this.getStatisticByEnterprise();//企业查询填报状态
      await this.getEnterpriseStatistic();// 查询认证 用于二次编辑
    },

    /** 企业查询填报状态*/
    getStatisticByEnterprise() {
      return new Promise(resolve => {
        let params = {
          id: this.$route.query.id
        };
        this.api.getStatisticByEnterprise(params).then(res => {
          if (res.error["err_code"] !== 0) return;
          resolve();
          let obj = res.obj.list[0] || null;
          this.StatisticByEnterprise = obj;
          if(obj){
            this.params = Object.assign({},{
              name:obj.name
            })
          }
        });
      });
    },
    /* 监测Props */
    needInfo(name) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[name]();
          watchAch(); //取消监听
        }
      });
    },
    /** 查询认证 用于二次编辑*/
    getEnterpriseStatistic() {
      let params = {
        statistic_project: this.$route.query.id
      };
      this.api.getEnterpriseStatistic(params).then(res => {
        if (res.error["err_code"] !== 0) return;
        let list = res.obj.list || [];

        let obj = list.length ? res.obj.list[0] : {};
        if (!list.length || obj.corporation_mobile === "") {
          //手机号
          obj.corporation_mobile = this.info.mobile;
        }
        this.params = Object.assign({}, this.params, obj);
      });
    },
   
  }
};
</script>

<style lang="scss" scoped>
.statistical_form_detail{
  .tit {
    .back {
      display: inline-block;
      width: 38px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      margin-right: 14px;
      cursor: pointer;
      vertical-align: middle;
    }
  }
  
  .my_row{
    text-align: center;
    line-height: 30px;
  }
  .StatisticByEnterprise{
    p{
      padding: 20px;
      border: 1px solid #999;
      font-size: 14px;
      line-height: 20px;
      background: #f0f0f0;
    }
    h2{
      font-weight: 700;
      font-size: 20px;
      text-align: center;
      line-height: 40px;
    }
  }
  
  .mystatisticalform{
    h2 {
      font-weight: 700;
      font-size: 20px;
      line-height: 40px;
    }
    p{
      border:none;
      background: none;
    }
  }
}
</style>